import React, { useEffect, useState } from "react";
import { ReactComponent as Logo } from "../img/logo.svg";
import OpenCollapse from "../img/collapse-to-right.svg";
import CloseCollapse from "../img/collapse-to-left.svg";
import Menu from "../img/menu.svg";
import CloseMenu from "../img/menu-close.svg";
import NotificationIcon from "./NotificationIcon";

export default function TopbarMobile(props) {
  const [isSidebarOpen, setIsSidebarOpen] = useState(() => {
    // Lista de términos específicos
    const terms = ["perfil/", "perfil", "cuestionarios", "cuestionarios/", "pacientes", "pacientes/", "configuracion", "configuracion/"];
  
    // Comprueba si el currentUrl existe y si termina con alguno de los términos
    return props.currentUrl ? terms.some(term => props.currentUrl.endsWith(term)) : false;
  });
  
  const [isNavMenuOpen, setIsNavMenuOpen] = useState(false);

  // Manejador para alternar la clase 'open' en el sidebar y cerrar nav-menu
  const toggleSidebar = () => {
    setIsSidebarOpen((prevState) => !prevState);
    setIsNavMenuOpen(false); // Cierra el nav-menu si está abierto
  };

  // Manejador para alternar la clase 'open' en el nav-menu y cerrar sidebar
  const toggleNavMenu = () => {
    setIsNavMenuOpen((prevState) => !prevState);
    setIsSidebarOpen(false); // Cierra el sidebar si está abierto
  };

  useEffect(() => {
    const terms = ["scl-90", "psqi", "who5", "analitica", "sueno", "creditos", "notificaciones"];
    const pacientesComplexPattern = /^\/?pacientes\/\d+\/\d+(\/[\w-]+)*\/\d+$/;
    const configuracionPattern = /^\/?configuracion\/.+/;
  
    if (
      props.currentUrl &&
      (
        (terms.some(term => props.currentUrl.includes(term)) && props.currentUrl.includes("perfil")) ||
        pacientesComplexPattern.test(props.currentUrl) ||
        props.currentUrl.includes("documentacion") ||
        configuracionPattern.test(props.currentUrl) ||
        props.currentUrl.includes("datos")
      )
    ) {
      setIsSidebarOpen(false);
    } else if (props.currentUrl && /pacientes\/\d+$/.test(props.currentUrl)) {
      setIsSidebarOpen(true);
    }
  }, [props.currentUrl]);
  
  

  useEffect(() => {
    const sidebarElement = document.getElementById("sidebar");
    const navMenuElement = document.getElementById("navigation-mobile");

    // Añadir o quitar la clase 'open' según el estado de isSidebarOpen
    if (sidebarElement) {
      if (isSidebarOpen) {
        sidebarElement.classList.add("open");
      } else {
        sidebarElement.classList.remove("open");
      }
    }

    // Añadir o quitar la clase 'open' según el estado de isNavMenuOpen
    if (navMenuElement) {
      if (isNavMenuOpen) {
        navMenuElement.classList.add("open");
      } else {
        navMenuElement.classList.remove("open");
      }
    }

    // Función que maneja el clic fuera del menú
    const handleClickOutside = (event) => {
      if (
        sidebarElement && !sidebarElement.contains(event.target) &&
        navMenuElement && !navMenuElement.contains(event.target) &&
        !event.target.closest("#topbar-mobile")
      ) {
        setIsSidebarOpen(false); // Cierra sidebar si clic fuera
        setIsNavMenuOpen(false); // Cierra nav-menu si clic fuera
      }
    };

    // Escuchar los clics en todo el documento
    document.addEventListener("mousedown", handleClickOutside);

    // Limpieza: eliminar el listener cuando el componente se desmonte
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
    
  }, [isSidebarOpen, isNavMenuOpen]);

  return (
    <>
      <div id="topbar-mobile">
        <div className="action-menu toggle-menu" onClick={toggleSidebar}>
          <img
            src={isSidebarOpen ? CloseCollapse : OpenCollapse}
            alt="Actions"
          />
        </div>
        <div className="logo logo-mobile">
          <Logo />
        </div>
        <div className="right-container">
          <div className="bell-active">
            <NotificationIcon {...props} />
          </div>
          <div className="nav-menu toggle-menu" onClick={toggleNavMenu}>
            <img src={isNavMenuOpen ? CloseMenu : Menu} alt="Menu" />
          </div>
        </div>
      </div>
    </>
  );
}
